function toggleFilter() {
  let x = document.querySelector(".sq-filter-main");
  x.classList.toggle("opening");
}
function toggleClass() {
  let y = document.querySelector(".sq-filter-main");
  y.classList.remove("opening");
}
function removeClass() {
  let z = document.querySelector(".sq-filter-main");
  z.classList.remove("opening");
}

window.sq = window.sq || {};

window.addEventListener("load", () => {
  if (window.matchMedia("(max-width: 767px)").matches) {
    document
      .getElementById("Search-In-Modal")
      .addEventListener("focusin", () => {
        document.querySelector(".sq-dropdown-body").style.maxHeight = "100%";
      });
    document
      .getElementById("Search-In-Modal")
      .addEventListener("focusout", () => {
        document.querySelector(".sq-dropdown-body").style.maxHeight = "0px";
      });
  }
});

window.sq.initSearch = (store) => {
  store.search();
};

setTimeout(() => {
  if (document.querySelector(".sq-filter-main"))
    document.querySelector(".sq-filter-main").style.visibility = null;
  if (document.querySelector(".sparq-container"))
    document.querySelector(".sparq-container").style.visibility = null;
}, 200);

window.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    document.querySelector("footer").click();
  }
});

/*jQuery(document).ready(function($){
  console.log('executing ');
});*/

/*
window.addEventListener('load', function() {
  setTimeout(()=>{
  

  console.log("hide popup.");
  // document.querySelector('.klaviyo-close-form').click();
  },1000)
});*/
/*



window.addEventListener("load", function () {
 setTimeout(()=>{
  
   const KEY = "popupLastShown3";
  const ONE_DAY = 24 * 60 * 60 * 1000;

  const popup = document.querySelector('.needsclick[aria-label="POPUP Form"]');
  const closeBtn = document.querySelector(".popup-close");

  const lastShown = localStorage.getItem(KEY);
  const now = Date.now();
  
 

  if (!lastShown || (now - lastShown > ONE_DAY)) {
    popup.classList.add("popupactive");
    
    localStorage.setItem(KEY, now);
   
  }
  else{
 document.querySelector('.klaviyo-close-form').click();
  setTimeout(()=>{
   popup.classList.add("popupactive");
  
 },500);
  }

 
  },2500)
  

});*/
/*window.addEventListener("DOMContentLoaded", function () {

  const triggers = document.querySelectorAll(".kl-teaser-TsqH7Z");
  const popup = document.querySelector('.needsclick[aria-label="POPUP Form"]'); // replace with your popup class

 if (e.target.closest(".kl-teaser-TsqH7Z")) {
    const popup = document.querySelector('.needsclick[aria-label="POPUP Form"]');
    popup?.parentElement.parentElement.classList.add("popupactive");
    alert('aee');
  }

});
document.addEventListener("click", function (e) {

  if (e.target.closest(".popup-close")) {
    const popup = document.querySelector('.needsclick[aria-label="POPUP Form"]');
    popup?.parentElement.parentElement.classList.remove("popupactive");
    alert('aee');
  }

});

$(document).ready(function(){

  $(".popup-close").on("click",function(){
  popup.classList.remove("popupactive");
  });
});
*/


